import {
  HiOutlineServer,
  HiOutlineDatabase,
  HiOutlineCube,
  HiOutlineColorSwatch,
} from 'react-icons/hi';
import { skills } from '../data/content';
import Reveal from './Reveal';
import './Skills.css';

const icons = {
  server: HiOutlineServer,
  database: HiOutlineDatabase,
  layout: HiOutlineColorSwatch,
  tools: HiOutlineCube,
};

const accents = ['violet', 'cyan', 'amber', 'emerald'];

export default function Skills() {
  return (
    <section id="skills" className="section skills">
      <div className="container">
        <Reveal className="section-head">
          <span className="eyebrow">Capabilities</span>
          <h2 className="section-title">
            The <span className="gradient-text">toolkit</span> I build with
          </h2>
          <p className="section-subtitle">
            A full-stack foundation centered on the .NET ecosystem, relational
            databases, and clean front-end work.
          </p>
        </Reveal>

        <div className="skills__grid">
          {skills.map((group, i) => {
            const Icon = icons[group.icon] || HiOutlineCube;
            const accent = accents[i % accents.length];
            return (
              <Reveal
                key={group.category}
                className={`skill-card card skill-card--${accent}`}
                delay={i * 0.08}
              >
                <div className="skill-card__top">
                  <span className="skill-card__icon">
                    <Icon />
                  </span>
                  <h3 className="skill-card__title">{group.category}</h3>
                </div>
                <ul className="skill-card__list">
                  {group.items.map((item) => (
                    <li key={item}>
                      <span className="skill-card__bullet" />
                      {item}
                    </li>
                  ))}
                </ul>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
